import {v4 as uuid} from 'uuid';
import {FeatureName} from '@contentlab/types/project';
import {CONTENT_LAB_VIEW_NAMES} from '@/lib/analytics/analyticsConstants';
import urlToFile from '@/utils/urlToFile';
import {onVideoUpload} from '../file-upload/utils';

export default async function downloadAndUploadAsset(
  assetUrl: string,
  fileName: string,
  feature: FeatureName | string,
  processEventHandlers: {
    started: (params: any) => void;
    ended: (params: any) => void;
  },
  onUploadError: (
    uniqueAssetId: string,
    file: File,
    errorCodes?: string[]
  ) => void
) {
  const blob = await urlToFile(assetUrl, fileName);
  const file = new File([blob], fileName, {type: 'video/mp4'});
  onVideoUpload({
    files: [file],
    feature,
    analyticsInteractionId: uuid(),
    analyticsLocation: CONTENT_LAB_VIEW_NAMES.ONBOARDING,
    processEventHandlers,
    onUploadError,
  });
}
